import { render, staticRenderFns } from "./BookingPresetBasicForm.vue?vue&type=template&id=4fd4710c&scoped=true&"
import script from "./BookingPresetBasicForm.vue?vue&type=script&lang=js&"
export * from "./BookingPresetBasicForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingPresetBasicForm.vue?vue&type=style&index=0&id=4fd4710c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4710c",
  null
  
)

export default component.exports